const initializeHeaderNavPc = () => {
  const headerNavEl = document.querySelector(".fs-header-nav-pc");
  addPcSubmenuEvents(headerNavEl);
};

const addPcSubmenuEvents = (headerNavEl) => {
  headerNavEl.querySelectorAll("nav .fs-nav-item.has-submenu").forEach((navItem) => {
    navItem.addEventListener("mouseover", (event) => {
      navItem.querySelector(".fs-submenu").classList.add("show");
    });
    navItem.addEventListener("mouseout", (event) => {
      hideAllSubmenus(headerNavEl);
    });
    const parentItems = navItem.querySelectorAll(".fs-submenu-collections .fs-submenu-item.parent");
    parentItems.forEach((parentItem) => {
      parentItem.addEventListener("mouseover", (event) => {
        const rect = parentItem.getBoundingClientRect();
        const submenu2 = parentItem.querySelector(".fs-submenu-2");
        const childItems = submenu2.querySelectorAll(".fs-submenu-item");
        const submenu2Height = Math.min(window.innerHeight - 48, 49 * childItems.length);
        const submenu2Bottom = Math.min(window.innerHeight - 24, rect.y + submenu2Height);
        const submenu2Y = submenu2Bottom - submenu2Height;
        submenu2.style.top = `${submenu2Y}px`;
        submenu2.style.left = `${rect.x + rect.width - 32}px`;
        submenu2.style.height = `${submenu2Height}px`;
        submenu2.style.opacity = "1";
        submenu2.classList.add("show");
      });
      parentItem.addEventListener("mouseout", (event) => {
        parentItem.querySelector(".fs-submenu-2").classList.remove("show");
      });
    });
  });
};

const hideAllSubmenus = (headerNavEl) => {
  headerNavEl.querySelectorAll(".fs-nav-item.has-submenu .fs-submenu").forEach((submenu) => {
    submenu.classList.remove("show");
  });
};

/*
 * Main
 */

const headerNavPcMain = () => {
  initializeHeaderNavPc();
};

addEventListener("DOMContentLoaded", (event) => {
  headerNavPcMain();
});
